import swisslogo from "../../../images/swiss-logo.svg";
import HolyFashionGroup from "../../../images/Holy-Fashion-Group_Logo.png";
import Papaya_Global_Logo from "../../../images/Papaya_Global_Logo.png";
import Experience_QBO_Services_Ltd from "../../../images/Experience_QBO_Services_Ltd.png";
import Experience_I_Know_First_Daily_Market_Forecast from "../../../images/Experience_I_Know_First_Daily_Market_Forecast.png";
import Experience_Sberbank from "../../../images/Experience_Sberbank.png";
import Certificate_VAVI_CitDevAutomationJunior from "../../../downloads/Certificate_VAVI_CitDevAutomationJunior.pdf";
import Reference_Letter_SWISS from "../../../downloads/VAVI_54387_Varanchuk_Viktoryia_Letter_of_reference.pdf";
import Reference_Letter_Papaya_Global from "../../../downloads/Reference_Papaya_Global.pdf";
import Reference_Letter_QBO_Services from "../../../downloads/Reference_QBO_Services_Ltd.pdf";
import Arbeitszeugnis_Viktoryia_Varanchuk_HFG from "../../../downloads/Arbeitszeugnis_Viktoryia_Varanchuk_HFG.pdf";
import RingierLogo from "../../../images/Ringier_Logo.png";

export const Experience = [
  {
    id: 0,
    src: RingierLogo,
    href: "https://www.ringier.com/de/",
    company: "Ringier AG",
    location: "Zürich, Schweiz",
    date: "Feb. 2026 – jetzt",
    position: "Junior Controllerin International Media / Sports Media",
    details: [
      "Verantwortung für das Reporting, die Budgetierung sowie die Forecasts inklusive aller vorbereitenden Abschlussarbeiten für internationale Medien- und Sportmedieneinheiten.",
      "Analyse und Kommentierung von Monats-, Quartals- und Jahresabschlüssen mit fundierten Soll-/Ist-Vergleichen für Einheiten in über 15 Ländern.",
      "Erstellung tiefgehender Analysen der internationalen Geschäftseinheiten zur Unterstützung strategischer Entscheidungen der Gruppen-Geschäftsleitung.",
      "Durchführung von Ad-hoc-Analysen und aktive Mitwirkung in bereichsübergreifenden Finanzprojekten.",
      "Kontinuierliche Weiterentwicklung der Finanzprozesse und -systeme zur Steigerung der Effizienz und Transparenz.",
      "Funktion als finanzieller Sparringspartner für die Gruppen-Geschäftsleitung und das lokale Management internationaler Einheiten.",
      "Arbeit mit SAP, Power BI und Excel zur Erstellung von Management-Reports und Dashboards für das internationale Media- und Sports-Media-Portfolio.",
    ],
  },
  {
    id: 1,
    src: HolyFashionGroup,
    href: "https://www.holyfashiongroup.de/",
    company: "Holy Fashion Group / Strellson AG",
    location: "Kreuzlingen, Schweiz",
    date: "Aug. 2025 – Feb. 2026",
    position: "Praktikantin im Finanzteam",
    details: [
      "Unterstützung bei Monats- und Jahresabschlüssen für mehrere Konzerngesellschaften unter Sicherstellung einer korrekten periodengerechten Abgrenzung und vollständigen Dokumentation.",
      "Durchführung von Intercompany-Buchungen und -Abstimmungen, inklusive Verbuchung, Ausgleich offener Posten und Erstellung von intercompany Rechnungen.",
      "Unterstützung im Bereich Anlagenbuchhaltung und Leasing, einschliesslich Aktivierung, Abschreibung und Kostenverteilung.",
      "Mitwirkung bei externen Reporting-Anforderungen, insbesondere bei der SNB CAS (Current Account Survey) – Aufbereitung und Klassifizierung grenzüberschreitender Transaktionen.",
      "Aufbereitung und Analyse von Finanz- und Bilanzdaten aus SAP Analytics Cloud (SAC), inklusive Excel-Exporten für Abschluss- und Reporting-Zwecke.",
      "Arbeit mit SAP S/4HANA, SAP Analytics Cloud und Excel zur Analyse finanzieller Daten und Sicherstellung der Reporting-Genauigkeit.",
      "Interdisziplinäre Zusammenarbeit mit verschiedenen Teams und Abteilungen zur kontinuierlichen Verbesserung der Buchhaltungsprozesse.",
    ],
    button: {
      href: Arbeitszeugnis_Viktoryia_Varanchuk_HFG,
      text: "Arbeitszeugnis",
      icon: "fa fa-file-pdf-o",
      download: "Arbeitszeugnis_Viktoryia_Varanchuk_HFG.pdf",
    },
  },
  {
    id: 2,
    src: swisslogo,
    href: "https://www.swiss.com/",
    company: "Swiss International Airlines AG",
    location: "Zürich, Schweiz",
    date: "Feb. 2025 – Aug. 2025",
    position: "Praktikantin im Financial Accounting Excellence & Services Team",
    details: [
      "Mitwirkung bei der Entwicklung und Implementierung neuer Finanzbuchhaltungsprozesse und -systeme zur Steigerung der betrieblichen Effizienz.",
      "Unterstützte die Analyse und Steuerung von Kreditoren- und Debitorenprozessen, die von Shared Service Centern in Krakau, Manila und Mexiko verwaltet werden.",
      "Dokumentierte und veranschaulichte Finanzprozesse, um die Transparenz und den Wissensaustausch zu verbessern.",
      "Leitete Finanzbuchhaltungsinitiativen und -projekte von der Planung bis zur Umsetzung mit.",
      "Unterstützte OKR-Initiativen (Objectives & Key Results) zur Verbesserung von Finanzmanagementmethoden.",
      "Zusammenarbeit mit funktionsübergreifenden Teams zur Entwicklung von Best-in-Class-Lösungen für die globale Finanzbuchhaltung.",
      "Arbeitete mit Power BI und Power Automate, um automatisierte Berichte und E-Mail-Workflows zu erstellen, einschliesslich Datenabfragen, JSON-Parsing, Zahlenformatierung und andere Datenumwandlungsaufgaben zur Unterstützung der Finanzvorgänge.",
    ],
    button: {
      href: Certificate_VAVI_CitDevAutomationJunior,
      text: "Microsoft Power Platform Zertifikat",
      icon: "fa fa-file-pdf-o",
      download: "Certificate_VAVI_CitDevAutomationJunior.pdf",
    },
    button2: {
      href: Reference_Letter_SWISS,
      text: "Arbeitszeugnis",
      icon: "fa fa-file-pdf-o",
      download: "VAVI_54387_Varanchuk_Viktoryia_Letter_of_reference.pdf",
    },
  },
  {
    id: 3,
    src: Papaya_Global_Logo,
    href: "https://www.papayaglobal.com/",
    company: "Papaya Global",
    location: "Herzliya, Israel",
    date: "Dez. 2021 – Juli 2024",
    position: "Kundenbetrieb und Payroll Journal Entry Controller",
    details: [
      "Verantwortlich für das Finanzmanagement von Grosskunden, einschliesslich der Steuerung komplexer Buchungsprozesse unter vollständiger Einhaltung internationaler Rechnungslegungsstandards.",
      "Konzeption und Einführung kundenspezifischer Reportinglösungen für internationale Konzerne, welche in einer effizienteren Prozessabwicklung resultierten.",
      "Erfolgreiche Leitung abteilungsübergreifender Projekte zur Optimierung des monatlichen Finanzreportings, mit nachweisbarer Qualitätssteigerung und schnellerer Bereitstellung.",
      "Implementierung automatisierter Systeme für Datenvalidierung und -abgleich bei einem beträchtlichen monatlichen Gehaltsabrechnungsvolumen.",
      "Funktion als zentrale Ansprechpartnerin für strategische Schlüsselkunden mit konstanter Kundenzufriedenheitsrate.",
    ],
    button: {
      href: Reference_Letter_Papaya_Global,
      text: "Arbeitszeugnis",
      icon: "fa fa-file-pdf-o",
      download: "Reference_Papaya_Global.pdf",
    },
  },
  {
    id: 4,
    src: Experience_QBO_Services_Ltd,
    href: "https://www.linkedin.com/company/q.b.o-services-ltd/about/",
    company: "Q.B.O Services Ltd",
    location: "Herzliya, Israel",
    date: "Apr. 2021 – Dez. 2021",
    position: "Junior Finanzanalystin",
    details: [
      "Entwicklung strategischer Finanzanalysen mittels Excel, Power BI und MySQL als Entscheidungsgrundlage für die Geschäftsführung.",
      "Durchführung detaillierter Risikoanalysen und GuV-Auswertungen zur Identifikation von Geschäftschancen und Optimierungspotenzialen.",
      "Eigenständige Betreuung des Asset-Management-Portfolios inklusive Bewertung, Kalkulation und Vertragserneuerung.",
      "Steigerung des Portfoliowachstums durch gezielte Marktanalysen und Identifikation lukrativer Investitionsmöglichkeiten.",
      "Aktive Mitwirkung bei der Entwicklung und Implementierung innovativer Finanzprodukte.",
    ],
    button: {
      href: Reference_Letter_QBO_Services,
      text: "Arbeitszeugnis",
      icon: "fa fa-file-pdf-o",
      download: "Reference_QBO_Services_Ltd.pdf",
    },
  },
  {
    id: 5,
    src: Experience_I_Know_First_Daily_Market_Forecast,
    href: "https://iknowfirst.com/",
    company: "I Know First: Daily Market Forecast",
    location: "Tel Aviv, Israel",
    date: "Nov. 2020 – Apr. 2021",
    position: "Praktikum als Finanzanalystin",
    details: [
      "Durchführung umfassender Fundamentalanalysen für über 100 Unternehmen in den USA, Grossbritannien und dem Nahen Osten.",
      "Erarbeitung überzeugender Investment Cases für vielversprechende Aktientitel zur Optimierung der Kundenportfolios.",
      "Steigerung der Website-Nutzung durch datenbasierte Content-Strategie und Traffic-Analysen.",
      "Erstellung fundierter Marktanalysen für institutionelle Kunden mit Fokus auf Wachstumsmärkten.",
    ],
  },
  {
    id: 6,
    src: Experience_Sberbank,
    href: "https://www.sberbank.com/index",
    company: "BPS-Sberbank",
    location: "Minsk, Belarus",
    date: "Jun. 2019 – Apr. 2020",
    position: "Marketing- und PR-Praktikantin",
    details: [
      "Durchführung einer strategischen Dreijahresanalyse zur Identifikation von Rentabilitätstreibern und Wachstumspotenzialen.",
      "Entwicklung erfolgreicher Produktstrategien mit nachweislicher Steigerung der Einlagenkonten.",
      "Optimierung der Produktentwicklung durch Implementierung von Design Thinking und Customer Journey Mapping.",
      "Erstellung entscheidungsrelevanter SWOT- und Rentabilitätsanalysen für das Kartenportfolio.",
    ],
  },
];
